import cantonTranslation from '@/utils/nationalRegion';
const filters = {
  //日期格式化
  formatDate: function (dates, fmt) {
    if (!dates) return '';
    let date = new Date(dates);
    if (date.toString() === 'Invalid Date') {
      dates = dates.replace(/-/g, '/');
      if (dates.indexOf('.') != -1) dates = dates.split('.')[0];
      date = new Date(dates);
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
      }
    }
    return fmt;
  },

  //行政区域转化
  getCanton: function (code) {
    return cantonTranslation[code];
  },
  getDate: function (date) {
    if (!date) return;
    return date.replace('T', ' ');
  },

  getFixed: function (val) {
    if (val) {
      return val.toFixed(2);
    } else {
      return '0.00';
    }
  },

  //取小数点后两位
  numFixed: function (val) {
    if (parseFloat(val) || parseFloat(val) === 0) {
      return parseFloat(val).toFixed(2);
    } else {
      return null;
    }
  },
  //取小数点后4位
  numFixed4: function (val) {
    if (parseFloat(val) || parseFloat(val) === 0) {
      return parseFloat(val).toFixed(4);
    } else {
      return null;
    }
  },
  //取小数点后4位,没有则返回0.0000
  toNumFixed4: function (val) {
    if (parseFloat(val) || parseFloat(val) === 0) {
      return parseFloat(val).toFixed(4);
    } else {
      return '0.0000';
    }
  },
  //取小数点后4位,没有则返回0.0000
  toNumFixed2: function (val) {
    if (parseFloat(val) || parseFloat(val) === 0) {
      return parseFloat(val).toFixed(2);
    } else {
      return '0.00';
    }
  },
  //千分位
  moneyFixed: function (val) {
    if (typeof (val) === 'number') {
      return (val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  },
  //手机号处理
  dealPhoneNum: function (val){
    if(val){
      return val.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2")
    }else{
      return ''
    }
  },
  // 身份证号处理
  dealIdCard: function (val){
    if(val){
      return val.replace(/^(.{6})(?:\d+)(.{2})$/ ,"$1**********$2")
    }else{
      return ''
    }
  },
  // 其他证件类型
  dealOtherIdCard: function (val){
    if(val){
      return val.substring(0, val.length - 4) + '****'
    }else{
      return ''
    }
  },
  // 银行账号处理
  dealBankAccount: function (val){
    if(val){
      return val.replace(/^(\d{4})\d+(\d{4})$/, "$1********$2")
    }else{
      return ''
    }
  },
};
export default filters;
